/* eslint-disable no-unused-vars */

const Liferay = window.Liferay || {
  authToken: "",
  OAuth2: {
    getAuthorizeURL: () => "",
    getBuiltInRedirectURL: () => "",
    getIntrospectURL: () => "",
    getTokenURL: () => "",
    getUserAgentApplication: (serviceName) => {},
  },
  OAuth2Client: {
    FromParameters: (options) => ({}),
    FromUserAgentApplication: (userAgentApplicationId) => ({}),
    fetch: (url, options = {}) => {},
  },
  Icons: {
    spritemap: "",
  },
  Language: {
    get: (key) => (key),
  },
  ThemeDisplay: {
    getCompanyGroupId: () => 0,
    getDefaultLanguageId: () => "es_PA",
    getLanguageId: () => "es_PA",
    getScopeGroupId: () => 0,
    getSiteGroupId: () => 0,
    isSignedIn: () => false,
  },
  Util: {
    openToast: () => {},
  },

};

export default Liferay;
